import * as _ from 'lodash'
import vehicleService from '../../services/vehicles'
import ativarTagItem from './ativar-tag/ativar-tag-item.vue'
import Tag from './aggregate/modal/aggregate-register/tag.vue';

export default {
  data() {
    return {
      vehicles: [],
      vehicleStatic: [],
      loading: undefined,
      erroMessage: undefined,
      length: 1,
      filter: undefined,
      aggregateVehicles: undefined,
      hasAggregate: false,
      loadingVehicles: false
    }
  },
  computed: {
    contracts(){
      // TODO tem que gravar os contratos em cookie
      return this.$store.state.contract.contracts;
    }
  },
  components: {
    ativarTagItem, Tag
  },
  watch: {
   
    filter(newFilter) {

      if(newFilter == undefined || newFilter.length == 0 || newFilter == ''){
        this.vehicles = this.vehicleStatic;
        this.length = this.vehicles.length;
        return ;
      }

      newFilter = newFilter.toUpperCase();
      this.vehicles = _.filter(this.vehicleStatic, (vehicle) => {

        return vehicle.plate.includes(newFilter)||
           vehicle.brandName.includes(newFilter) ||
           vehicle.modelName.toUpperCase().includes(newFilter);
      });
      this.length = this.vehicles.length;
    }
  },
  mounted() {
    this.contracts && this.contracts.find(contract => {
      if (contract.plan.planId == 45 || contract.plan.planId == 46) {
        this.hasAggregate = true;
      }
    })

    const getVehiclesForActivate = vehicleService.getVehiclesForActivate();
    const getVehiclesForActivateAgg = vehicleService.getVehiclesForActivateAgg();

    this.loadingVehicles = true;

    this.loading = Promise.all([getVehiclesForActivate, getVehiclesForActivateAgg]).then(response => {
      const [ vehicles, aggregateVehicles ] = response;

      this.vehicles = vehicles;
      this.vehicleStatic = this.vehicles;
      this.length = this.vehicles.length;

      if(this.hasAggregate) {
        this.aggregateVehicles = aggregateVehicles;
      }
    }).finally(() => {
      this.loadingVehicles = false;
    });
  },
  methods: {
    activatingTag(promise) {
      this.loading = promise;

    },
    deactivatetagLoading() {
      this.loading = Promise.resolve(true);
    }
  },
}



// WEBPACK FOOTER //
// ./src/pages/account/tag-activate.js